var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',[(!_vm.loading)?_c('grid-item',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{staticClass:"child"})],1)],1):_c('grid-item',[_c('Loader',{attrs:{"color":"#759add"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }